import type { Appearance } from "@clerk/types";

/** Agent / customer SPA — light card; OAuth labels stay dark-on-light for contrast. */
export const agentPublicAuthAppearance: Appearance = {
  variables: {
    colorPrimary: "#c2410c",
    colorPrimaryForeground: "#ffffff",
    colorForeground: "#1c1917",
    colorMutedForeground: "#78716c",
    colorBackground: "#ffffff",
    colorInput: "#faf8f5",
    colorInputForeground: "#1c1917",
    colorNeutral: "#d6d3d1",
    borderRadius: "12px",
  },
  elements: {
    rootBox: { width: "100%" },
    /** Single surface — no extra outer card (avoids double-box misalignment) */
    card: {
      width: "100%",
      backgroundColor: "#ffffff",
      border: "1px solid var(--sdw-border)",
      borderRadius: "14px",
      boxShadow: "0 1px 3px rgba(28, 25, 23, 0.08)",
    },
    socialButtonsBlockButton: {
      color: "#1c1917",
      borderColor: "var(--sdw-border)",
      backgroundColor: "#faf8f5",
    },
    socialButtonsBlockButtonText: {
      color: "#1c1917",
    },
  },
};
